import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getVisualBuilderBasePayload } from "@src/store/slices/experienceBuilder/common/selectors/getVisualBuilderTrackingContext";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { selectedVariations } from "@src/store/slices/variations";
import { mpVisualBuilderDiscardModalClosed } from "@src/utils/mixpanel";

export interface TrackDiscardModalClosedPayload {
  choice:
    | "keep_editing"
    | "discard_and_exit"
    | "save_and_exit"
    | "apply_changes";
}

export const trackDiscardModalClosed = createAsyncThunk<
  void,
  TrackDiscardModalClosedPayload
>("experienceBuilder/tracking/discardModalClosed", (payload, { getState }) => {
  const basePayload = getVisualBuilderBasePayload(getState());
  if (basePayload) {
    const mods = experienceBuilderSlice.selectors.getMods(getState());
    const variationId =
      experienceBuilderSlice.selectors.getVariationId(getState());
    const variationMods = mods.filter((m) => m.variationId === variationId);
    const device = experienceBuilderSlice.selectors.getDevice(getState());

    const variations = selectedVariations(getState());
    mpVisualBuilderDiscardModalClosed({
      ...basePayload,
      test_group_count: variations.length,
      choice: payload.choice,
      mod_count: variationMods.length,
      builder_mode: device,
    });
  }
});
